import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// Layouts
import MainLayout from '@/layouts/MainLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'

// Auth Pages
import Login from '@/views/auth/Login.vue'
import Register from '@/views/auth/Register.vue'

// Main Pages
import Dashboard from '@/views/Dashboard.vue'
import Profiles from '@/views/Profiles.vue'
import ProfileDetail from '@/views/ProfileDetail.vue'
import Calls from '@/views/Calls.vue'
import Schedule from '@/views/Schedule.vue'
import Analytics from '@/views/Analytics.vue'
import Alerts from '@/views/Alerts.vue'
import Settings from '@/views/Settings.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/',
    component: AuthLayout,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: { requiresGuest: true }
      },
      {
        path: 'register',
        name: 'Register',
        component: Register,
        meta: { requiresGuest: true }
      }
    ]
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'profiles',
        name: 'Profiles',
        component: Profiles
      },
      {
        path: 'profiles/:id',
        name: 'ProfileDetail',
        component: ProfileDetail,
        props: true
      },
      {
        path: 'calls',
        name: 'Calls',
        component: Calls
      },
      {
        path: 'schedule',
        name: 'Schedule',
        component: Schedule
      },
      {
        path: 'analytics',
        name: 'Analytics',
        component: Analytics
      },
      {
        path: 'alerts',
        name: 'Alerts',
        component: Alerts
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // Check if route requires authentication
  if (to.meta.requiresAuth) {
    if (!authStore.isAuthenticated) {
      return next('/login')
    }
    
    // Verify token is still valid
    const isValid = await authStore.checkAuth()
    if (!isValid) {
      return next('/login')
    }
  }
  
  // Check if route requires guest (not logged in)
  if (to.meta.requiresGuest && authStore.isAuthenticated) {
    return next('/dashboard')
  }
  
  next()
})

export default router